export type IProps = {
  onBack: () => void;
  onNext: () => void;
};

export enum TStatus {
  ANALYSIS = 'analysis',
  APPROVED = 'approved',
  REPROVED = 'reproved',
}
